<template>
  <nav class="navbar-desktop">
    <div class="navbar-brand">
      <!-- <router-link to="/">Logo</router-link> -->
      <img src="../assets/img/homePage/logo.png" alt="" />
      <div class="headerBox">
        <span class="span1">Innovative Pay</span>
        <!-- <span class="span2">EXKLUSIV LOUNGEWEAR LTD</span> -->
      </div>
    </div>
    <ul class="navbar-menu">
      <li>
        <router-link to="/">‌{{ $t("home") }}</router-link>
      </li>
      <li>
        <router-link :to="{ path: '/', hash: '#homePage1' }"
          >‌{{ $t("Solution") }}</router-link
        >
        <!-- <router-link
          to="/aboutPage"
          class="disabled-link"
          aria-disabled="true"
          @click.prevent
          >‌{{ $t("Solution") }}</router-link
        > -->
      </li>
      <li>
        <router-link :to="{ path: '/', hash: '#homePage2' }">{{
          $t("Focused")
        }}</router-link>
        <!-- <router-link
          to="/ourSecurity"
          class="disabled-link"
          aria-disabled="true"
          @click.prevent
          >{{ $t("Focused") }}</router-link
        > -->
      </li>
      <li>
        <router-link :to="{ path: '/', hash: '#homePage3' }">{{
          $t("Technology")
        }}</router-link>
        <!-- <router-link
          to="/ourHelp"
          class="disabled-link"
          aria-disabled="true"
          @click.prevent
          >{{ $t("Technology") }}</router-link
        > -->
      </li>
      <li>
        <router-link :to="{ path: '/ourHelp', hash: '#efficiency' }"
          >{{ $t("Efficiency") }}
        </router-link>
      </li>
      <li>
        <router-link :to="{ path: '/ourHelp', hash: '#scale' }"
          >{{ $t("Scale") }}
        </router-link>
      </li>
      <custom-dropdown @selected="handleSelection"></custom-dropdown>
    </ul>
  </nav>
</template>

<script>
import CustomDropdown from "./CustomDropdown.vue"
export default {
  name: "NavbarDesktop",
  components: {
    CustomDropdown,
  },
  methods: {
    handleSelection(option) {
      console.log("选中的选项:", option)

      const newLocale = option === "English" ? "en" : "ur"
      this.$i18n.locale = newLocale
      if (typeof localStorage !== "undefined") {
        localStorage.setItem("locale", newLocale)
      }
      if (typeof document !== "undefined") {
        const html = document.documentElement
        html.setAttribute("dir", newLocale === "ur" ? "rtl" : "ltr")
        html.setAttribute("lang", newLocale)
      }
      // 在这里处理选中的选项
    },
  },
}
</script>

<style scoped>
* {
  box-sizing: border-box;
}

.navbar-desktop {
  width: 100vw;
  height: 5.25rem;
  padding: 1rem;
  position: fixed;
  left: 0px;
  top: 0px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 20rem;
  background-color: #7678f3;
  color: var(--fontColor);
  /* box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); */
  z-index: 1000;
}

.navbar-brand {
  display: flex;
  align-items: center;
}

.navbar-brand img {
  width: 36px;
  height: 37px;
  /* border-radius: 50%; */
  margin-right: 1.25rem;
}

.headerBox {
  display: flex;
  flex-direction: column;
}

.span1 {
  font-weight: 500;
  font-size: 1.5rem;
  color: #ffffff;
  margin-bottom: 0.5rem;
}
.span2 {
  font-size: 1rem;
}
.navbar-menu {
  display: flex;
  list-style: none;
  align-items: center;
  margin: 0;
  padding: 0;
}

.navbar-menu li {
  margin-left: 2rem;
  font-size: 1.375rem;
  height: 3.3125rem;

  text-align: center;
  line-height: 3.3125rem;
}

.navbar-menu a {
  color: var(--fontColor);
  padding: 0.625rem;
  width: 100%;
  height: 100%;
  text-decoration: none;
  transition: opacity 0.2s ease;
}

.navbar-menu a:hover {
  /* font-weight: bold; */
  color: #fbf9ff;
  /* background-color: #fff; */

  border-radius: 1.6875rem;
}

.navbar-menu .router-link-exact-active {
  /* font-weight: bold; */
  color: #fbf9ff;
  /* background-color: #fff; */

  border-radius: 1.6875rem;
  opacity: 0.6;
}
[dir="rtl"] .navbar-desktop {
  direction: ltr;
}
[dir="rtl"] .navbar-brand img {
  transform: none;
}

.disabled-link {
  pointer-events: none;
  cursor: not-allowed;
}
</style>
